// Reference data for RDC hotel platform dropdowns (Exigence 6.1)

export const PROVINCES_RDC = [
  'Bas-Uele', 'Équateur', 'Haut-Katanga', 'Haut-Lomami', 'Haut-Uele',
  'Ituri', 'Kasaï', 'Kasaï-Central', 'Kasaï-Oriental', 'Kinshasa',
  'Kongo-Central', 'Kwango', 'Kwilu', 'Lomami', 'Lualaba',
  'Mai-Ndombe', 'Maniema', 'Mongala', 'Nord-Kivu', 'Nord-Ubangi',
  'Sankuru', 'Sud-Kivu', 'Sud-Ubangi', 'Tanganyika', 'Tshopo', 'Tshuapa',
];

export const STAR_CATEGORIES = [
  { value: '1', label: '1 étoile ★' },
  { value: '2', label: '2 étoiles ★★' },
  { value: '3', label: '3 étoiles ★★★' },
  { value: '4', label: '4 étoiles ★★★★' },
  { value: '5', label: '5 étoiles ★★★★★' },
];

export const LEGAL_FORMS = [
  { value: 'SARL', label: 'SARL - Société à Responsabilité Limitée' },
  { value: 'SA', label: 'SA - Société Anonyme' },
  { value: 'SNC', label: 'SNC - Société en Nom Collectif' },
  { value: 'SCS', label: 'SCS - Société en Commandite Simple' },
  { value: 'EI', label: 'EI - Entreprise Individuelle' },
  { value: 'COOP', label: 'Coopérative' },
  { value: 'ASBL', label: 'ASBL - Association Sans But Lucratif' },
  { value: 'OTHER', label: 'Autre' },
];

export const ESTABLISHMENT_TYPES = [
  { value: 'hotel', label: 'Hôtel' },
  { value: 'motel', label: 'Motel' },
  { value: 'auberge', label: 'Auberge' },
  { value: 'residence', label: 'Résidence hôtelière' },
  { value: 'guesthouse', label: 'Maison d\'hôtes' },
  { value: 'lodge', label: 'Lodge' },
  { value: 'resort', label: 'Resort' },
  { value: 'apart_hotel', label: 'Appart-hôtel' },
  { value: 'camping', label: 'Camping' },
  { value: 'other', label: 'Autre' },
];

export const PAYMENT_METHODS_OPTIONS = [
  { value: 'cash', label: 'Espèces' },
  { value: 'visa', label: 'Visa' },
  { value: 'mastercard', label: 'Mastercard' },
  { value: 'mobile_money', label: 'Mobile Money' },
  { value: 'bank_transfer', label: 'Virement bancaire' },
  { value: 'check', label: 'Chèque' },
];

// Restaurant reference data (Exigence 6.3)
export const CUISINE_TYPES = [
  { value: 'congolaise', label: 'Cuisine congolaise' },
  { value: 'africaine', label: 'Cuisine africaine' },
  { value: 'française', label: 'Cuisine française' },
  { value: 'italienne', label: 'Cuisine italienne' },
  { value: 'asiatique', label: 'Cuisine asiatique' },
  { value: 'libanaise', label: 'Cuisine libanaise' },
  { value: 'indienne', label: 'Cuisine indienne' },
  { value: 'internationale', label: 'Cuisine internationale' },
  { value: 'fast_food', label: 'Fast-food' },
  { value: 'grillades', label: 'Grillades / Barbecue' },
  { value: 'fruits_de_mer', label: 'Fruits de mer' },
  { value: 'vegetarienne', label: 'Cuisine végétarienne' },
  { value: 'mixte', label: 'Mixte / Variée' },
  { value: 'autre', label: 'Autre' },
];

export const OPERATION_MODES = [
  { value: 'interne', label: 'Gestion interne (par l\'hôtel)' },
  { value: 'franchise', label: 'Franchise' },
  { value: 'concession', label: 'Concession' },
  { value: 'partenariat', label: 'Partenariat' },
  { value: 'independant', label: 'Indépendant' },
  { value: 'autre', label: 'Autre' },
];

export const RESTAURANT_TYPES = [
  { value: 'restaurant', label: 'Restaurant classique' },
  { value: 'brasserie', label: 'Brasserie' },
  { value: 'bar_restaurant', label: 'Bar-restaurant' },
  { value: 'snack', label: 'Snack / Fast-food' },
  { value: 'buffet', label: 'Buffet' },
  { value: 'terrasse', label: 'Terrasse / Rooftop' },
  { value: 'cafe', label: 'Café / Salon de thé' },
  { value: 'autre', label: 'Autre' },
];

export const RESTAURANT_STATUSES = [
  { value: 'active', label: 'Actif' },
  { value: 'inactive', label: 'Inactif' },
  { value: 'suspended', label: 'Suspendu' },
];


// ISO Nationalities list for police form (Exigence 6.4)
export const ISO_NATIONALITIES = [
  'Afghane', 'Albanaise', 'Algérienne', 'Allemande', 'Américaine', 'Andorrane',
  'Angolaise', 'Argentine', 'Arménienne', 'Australienne', 'Autrichienne',
  'Azerbaïdjanaise', 'Bahreïnienne', 'Bangladaise', 'Belge', 'Béninoise',
  'Bhoutanaise', 'Biélorusse', 'Birmane', 'Bolivienne', 'Bosnienne',
  'Botswanaise', 'Brésilienne', 'Britannique', 'Brunéienne', 'Bulgare',
  'Burkinabè', 'Burundaise', 'Cambodgienne', 'Camerounaise', 'Canadienne',
  'Cap-Verdienne', 'Centrafricaine', 'Chilienne', 'Chinoise', 'Chypriote',
  'Colombienne', 'Comorienne', 'Congolaise (RDC)', 'Congolaise (RC)',
  'Costa-Ricaine', 'Croate', 'Cubaine', 'Danoise', 'Djiboutienne',
  'Dominicaine', 'Dominiquaise', 'Égyptienne', 'Émirienne', 'Équatorienne',
  'Érythréenne', 'Espagnole', 'Estonienne', 'Éthiopienne', 'Fidjienne',
  'Finlandaise', 'Française', 'Gabonaise', 'Gambienne', 'Géorgienne',
  'Ghanéenne', 'Grecque', 'Guatémaltèque', 'Guinéenne', 'Guinéenne-Bissau',
  'Guyanienne', 'Haïtienne', 'Hondurienne', 'Hongroise', 'Indienne',
  'Indonésienne', 'Irakienne', 'Iranienne', 'Irlandaise', 'Islandaise',
  'Israélienne', 'Italienne', 'Ivoirienne', 'Jamaïcaine', 'Japonaise',
  'Jordanienne', 'Kazakhe', 'Kényane', 'Kirghize', 'Koweïtienne',
  'Laotienne', 'Lesothane', 'Lettone', 'Libanaise', 'Libérienne',
  'Libyenne', 'Liechtensteinoise', 'Lituanienne', 'Luxembourgeoise',
  'Macédonienne', 'Malgache', 'Malaisienne', 'Malawienne', 'Maldivienne',
  'Malienne', 'Maltaise', 'Marocaine', 'Mauricienne', 'Mauritanienne',
  'Mexicaine', 'Moldave', 'Monégasque', 'Mongole', 'Monténégrine',
  'Mozambicaine', 'Namibienne', 'Népalaise', 'Nicaraguayenne', 'Nigériane',
  'Nigérienne', 'Nord-Coréenne', 'Norvégienne', 'Néo-Zélandaise',
  'Omanaise', 'Ougandaise', 'Ouzbèke', 'Pakistanaise', 'Palestinienne',
  'Panaméenne', 'Papouane-Néo-Guinéenne', 'Paraguayenne', 'Péruvienne',
  'Philippine', 'Polonaise', 'Portugaise', 'Qatarienne', 'Roumaine',
  'Russe', 'Rwandaise', 'Saoudienne', 'Sénégalaise', 'Serbe',
  'Sierra-Léonaise', 'Singapourienne', 'Slovaque', 'Slovène', 'Somalienne',
  'Soudanaise', 'Sri-Lankaise', 'Sud-Africaine', 'Sud-Coréenne',
  'Sud-Soudanaise', 'Suédoise', 'Suisse', 'Surinamaise', 'Swazie',
  'Syrienne', 'Tadjike', 'Tanzanienne', 'Tchadienne', 'Tchèque',
  'Thaïlandaise', 'Togolaise', 'Tongienne', 'Trinidadienne', 'Tunisienne',
  'Turkmène', 'Turque', 'Ukrainienne', 'Uruguayenne', 'Vanuatuane',
  'Vénézuélienne', 'Vietnamienne', 'Yéménite', 'Zambienne', 'Zimbabwéenne',
  'Autre',
];

// Stay purpose options for police form (Exigence 5.1)
export const STAY_PURPOSES = [
  { value: 'tourisme', label: 'Tourisme' },
  { value: 'affaires', label: 'Affaires' },
  { value: 'mission_officielle', label: 'Mission officielle' },
  { value: 'conference', label: 'Conférence / Séminaire' },
  { value: 'medical', label: 'Raison médicale' },
  { value: 'familial', label: 'Visite familiale' },
  { value: 'etudes', label: 'Études / Formation' },
  { value: 'transit', label: 'Transit' },
  { value: 'humanitaire', label: 'Mission humanitaire' },
  { value: 'diplomatique', label: 'Mission diplomatique' },
  { value: 'autre', label: 'Autre' },
];

// Document type options for police form (Exigence 6.4)
export const DOCUMENT_TYPES = [
  { value: 'Passport', label: 'Passeport' },
  { value: 'National ID Card (CNI)', label: 'Carte Nationale d\'Identité (CNI)' },
  { value: 'Driving License', label: 'Permis de conduire' },
  { value: 'Visa', label: 'Visa' },
  { value: 'Carte de séjour', label: 'Carte de séjour' },
  { value: 'Carte consulaire', label: 'Carte consulaire' },
];
